// extracted by mini-css-extract-plugin
export default {"nextplaying":"NextPlaying_nextplaying__tFRUB","tickertext":"NextPlaying_tickertext__qAG+l"};